import React, { useEffect, useState, memo, useRef } from "react";
import { useDispatch } from 'react-redux';
import { connect } from "react-redux";
import { compose } from "redux";
import { getDepartments, getAllDepartments, getCompanies } from "../../store/actions/departmentActions";
import { getComplianceStandardsByCompany, setActiveCompliance } from "../../store/actions/complianceActions";
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import Meters from "../../components/Meters/Meters";
import DepartmentDashboard from "../../components/Dashboards/Department";
import RiskDashboard from "../../components/Dashboards/RiskDashboard";
import { resetGotoRiskDashboard, resetGotoBowtie, closeOverlay } from "../../store/actions/riskActions";
import { getDepartmentDashboardData } from "../../store/actions/dashboardActions";
import { resetDepartmentDashboard } from "../../store/actions/departmentActions";
import { setActiveDepartment } from "../../store/actions/departmentActions";
import { setSidebarCollapsed } from "../../store/actions/authActions";
import UnitsSideBar from "../../components/UnitsSideBar";
import UnitsTopBar from "../../components/UnitsTopBar";
import Files from "../../components/Files/Files";
import Risk from "../risk/Risk";
import Reports from "./Reports";
import Gantt from "../risk/Gantt";
import Control from "./Control"
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Report from "../../components/Report/ReportOverlay";
import ITInventory from "../it/ITInventory";
import ComplianceAssets from '../compliance/ComplianceAssets';
import Workflows from "../compliance/Workflows";
import ComplianceWorkflow from "../compliance/ComplianceWorkflow";
import WorkflowEditor from "../../components/Workflow/WorkflowEditor";

import { Panel } from 'reactflow';
import IncidentList from "../../components/Incidents/IncidentList";
import ComplianceRisk from "../compliance/ComplianceRisk";
import ComplianceControl from "../compliance/ComplianceControl";
import ComplianceFiles from "../../components/Files/ComplianceFiles";
import ComplianceGanttPage from "../compliance/ComplianceGanttPage";
import ComplianceDashboard from "../../components/Dashboards/ComplianceDashboard";
import ComplianceTopBar from "../../components/ComplianceTopBar";



function Units(props) {
    const { sidebar_collapsed, setSidebarCollapsedFN, setActiveComplianceFN, activeComplianceId, complianceStandards, getComplianceStandardsByCompanyFN, token, departments, companies, getDepartmentsFN, getCompaniesFN, getAllDepartmentsFN, match, resetGotoRiskDashboardFN, resetGotoBowtieFN, resetDepartmentDashboardFN, setActiveDepartmentId, activeDepartmentId, getDepartmentDashboardDataFN } = props;
    const { id } = useParams();
    const location = useLocation();
    const departmentfromredirect = location.state?.departmentfromredirect;
    const ComplianceFromRedirect = location.state?.ComplianceFromRedirect;
    const activeMenuItem = location.state?.activeMenuItem;

    const [activeriskforworkflow, setActiveRiskForWorkflow] = useState(null);
    const [activeassetforworkflow, setActiveAssetForWorkflow] = useState(null);

    ////////console.log("token:", token);
    //const departments = ["General", "Financial", "Marketing", "Pricing", "IT", "HR", "Project", "Management"];
    const [activeDepartment, setActiveDepartment] = useState("General");

    const [activeCompliance, setActiveCompliance] = useState(0);
    //const [activeDepartmentId, setActiveDepartmentId] = useState(null);
    //const [activeRiskId, setActiveRiskId] = useState(null);
    //const [selectedDepartment, setSelectedDepartment] = useState(null); // New state for Select component

    const [menuitem, setMenuItem] = useState("dashboards");
    const [isReportOpen, setIsReportOpen] = useState(false);

    const [departmentDashboardData, setDepartmentDashboardData] = useState(null); // State in the parent
    const [generalDashboardData, setGeneralDashboardData] = useState(null); // State in the parent
    //const [activeComplianceId, setactiveComplianceId] = useState(activeCompliance?.compliance_id || null)

    //const activeComplianceId = activeCompliance?.compliance_id || null;
    ////console.log(activeComplianceId)
    const isComplianceView = !!activeComplianceId;



    const openReport = () => {
       

        // Check if there are any risks in the summary
        const hasRisks = departmentDashboardData.risk_summary?.length > 0;

        if (!hasRisks) {
            alert("Please approve some risks before generating the report.");
            return;
        }

        setIsReportOpen(true);
    };

    //////console.log("departmentDashboardData", departmentDashboardData);


    useEffect(() => {
        //resetDepartmentDashboardFN();
        resetGotoRiskDashboardFN();
        resetGotoBowtieFN();
        getDepartmentsFN();
        getCompaniesFN();
        getComplianceStandardsByCompanyFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     //resetDepartmentDashboardFN();
    //     resetGotoBowtieFN();
    //     getDepartmentsFN();
    //     getCompaniesFN();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    useEffect(() => {
        //////console.log("activeDepartmnetId", activeDepartmentId);
        //////console.log("activeDepartmnet", activeDepartment);

        getDepartmentDashboardDataFN(activeDepartmentId);
        //////console.log("departmentDashboard data NEW!!!", departmentDashboardData);
    }, [menuitem, activeDepartmentId]);



    useEffect(() => {
        if (departmentfromredirect) {
            resetDepartmentDashboardFN();
            //alert(1);
            let actual_department = departments && departments.find(department => department.department_id === departmentfromredirect);
            setActiveDepartment(actual_department.name);
            setActiveDepartmentId(departmentfromredirect);
            setActiveComplianceFN(null);
            //getDepartmentsFN(e.value);
            // setActiveRiskId(null);
            ////console.log("departmentfromredirect", departmentfromredirect)


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [departmentfromredirect]);


        useEffect(() => {
        if (ComplianceFromRedirect) {
            //console.log(ComplianceFromRedirect)
            resetDepartmentDashboardFN();
            //alert(1);
            let actual_compliance = complianceStandards && complianceStandards.find(department => department.compliance_id === ComplianceFromRedirect);
            setActiveCompliance(actual_compliance);
            //setactiveComplianceId(ComplianceFromRedirect)
            //getDepartmentsFN(e.value);
            // setActiveRiskId(null);
            ////console.log("departmentfromredirect", departmentfromredirect)


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ComplianceFromRedirect]);



    useEffect(() => {
        if (departments && departments?.length > 0 && !departmentfromredirect) {
            //alert(0);
            setActiveDepartment(departments[0].name);
            setActiveDepartmentId(departments[0].department_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    /*
    useEffect(() => {
        if (departments && departments?.length > 0) {
            setActiveDepartment(departments[0].name);
            setActiveDepartmentId(departments[0].department_id);
        }
    }, [departments]);
    */

    useEffect(() => {
        if (match.params.id) {
            //setActiveRiskId(match.params.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match.params.id]);

    useEffect(() => {
        if (activeMenuItem) {
            setMenuItem(activeMenuItem);
        }
    }, [activeMenuItem]);

    useEffect(() => {
        if (typeof window === "undefined") return;
        const mq = window.matchMedia("(max-width: 1023px)");
        if (mq.matches) setSidebarCollapsedFN(true);
    }, [setSidebarCollapsedFN]);

    const changeActiveDepartment = (department_id) => {

        ////console.log("here ", department_id)
        let actual_department = departments && departments.find(department => department.department_id === department_id);
        setActiveDepartment(actual_department.name);
        setActiveDepartmentId(department_id);
        setActiveComplianceFN(null);
        //setactiveComplianceId(null);
        //getDepartmentsFN(e.value);
        //  setActiveRiskId(null);

        //if (history.location.pathname !== '/dashboards') history.push('/dashboards')
    }

    const changeActiveCompliance = (compliance) => {


        setActiveCompliance(compliance)
        setActiveComplianceFN(compliance.compliance_id)
        //setactiveComplianceId(compliance.compliance_id)
        setMenuItem("dashboards");
        //console.log("compliance ", compliance)
    }



    return token ? (

        <div className="flex h-screen w-full flex-col overflow-hidden">
            <div className="shrink-0">
                <TopBar className="fixed top-0 left-0 right-0 z-10" />
            </div>

            {/* Row with Sidebar and Dashboard Content — flex-1 so it only fills space below TopBar */}
            <div className="flex min-h-0 w-full flex-1 flex-row">
                <Sidebar className="fixed left-0 top-0 h-screen z-30 w-16" />

                {/* Mobile: full-height sheet from left edge, below TopBar (pt-16), above main content */}
                {!sidebar_collapsed ? (
                    <button
                        type="button"
                        aria-label="Close risk centers menu"
                        className="fixed inset-x-0 bottom-0 top-24 z-[78] bg-black/40 md:hidden"
                        onClick={() => setSidebarCollapsedFN(true)}
                    />
                ) : null}

                <UnitsSideBar
                    className="fixed left-0 z-[82] flex min-h-0 flex-col overflow-hidden bg-[#F4F4F4] max-md:top-24 max-md:h-[calc(100dvh-6rem)] max-md:max-h-[calc(100dvh-6rem)] max-md:shadow-[4px_0_24px_rgba(0,0,0,0.15)] md:top-0 md:left-16 md:z-20 md:h-screen md:shadow-none"
                    setActiveDepartment={changeActiveDepartment}
                    setActiveCompliance={changeActiveCompliance}
                    activeDepartmentId={activeDepartmentId}
                    departments={departments}
                    companies={companies}
                />

                { }
                {/*
                  Desktop: primary Sidebar is already md:relative w-16 in the flex row, so the main
                  column starts at 64px. Do not add ml-16 again (was double offset). When the Units
                  tree is open, add only the panel width (218px), not 64+218.
                  Mobile: no horizontal margin (full width); Units sheet overlays.
                */}
                <div
                    className={`flex min-h-0 min-w-0 w-full flex-1 flex-col max-md:ml-0
                    }`}
                >
                    {/*
                      Sub-nav must stay in document flow (not fixed top-16). TopBar wraps on mobile
                      (~2 rows) while fixed assumed 64px, so tabs sat under the search row. Scroll
                      lives in children below; this bar stays visible as a sibling above them.
                    */}
                    {isComplianceView ? (
                        <ComplianceTopBar
                            className="z-[60] w-full shrink-0"
                            menuitem={menuitem}
                            setMenuItem={setMenuItem}
                            activeComplianceId={activeComplianceId}
                            complianceStandards={complianceStandards}
                        />
                    ) : (
                        <UnitsTopBar
                            className="z-[60] w-full shrink-0"
                            menuitem={menuitem}
                            setMenuItem={setMenuItem}
                            activeDepartmentId={activeDepartmentId}
                            departments={departments}
                            openReport={openReport}
                        />
                    )}

                    {isComplianceView ? (
                        // =========================
                        // COMPLIANCE MODE
                        // =========================
                        <>
                            {menuitem === "dashboards" ? (
                                <div id="dashboard-content" className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-auto px-2 py-3 sm:p-4">
                                    <ComplianceDashboard
                                        compliance_id={activeComplianceId}
                                        setComplianceDashboardData={setDepartmentDashboardData}
                                    />
                                </div>
                            ) : menuitem === "risk" ? (
                                <ComplianceRisk activeComplianceStandardId={activeComplianceId} />
                            ) : menuitem === "files" ? (
                                  <Files compliance_id={activeComplianceId} isComp={true}/>
                            ) : menuitem === "controls" ? (
                                <ComplianceControl activeComplianceId={activeComplianceId} />
                            ) : menuitem === "actions" ? (
                                <ComplianceGanttPage activeComplianceId={activeComplianceId} />
                            ) : menuitem === "incidents" ? (
                                <IncidentList activeDepartmentId={activeComplianceId} isCompliance={true} />
                            ) : menuitem === "inventory" ? (
                                <ComplianceAssets />
                            ) : menuitem === "workflows" ? (
                                <ComplianceWorkflow />
                            ) : menuitem === "create_report" ? (
                                <Reports isComp={true}/>
                            ) : (
                                <div> Default Page </div>
                            )}
                        </>
                    ) : (
                        // =========================
                        // DEPARTMENT MODE
                        // =========================
                        <>
                            {menuitem === "dashboards" ? (
                                <div id="dashboard-content" className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-auto px-2 py-3 sm:p-4">
                                    <div className="flex w-full min-w-0 flex-wrap">
                                        <div className="min-w-0 flex-1">
                                            {activeDepartment !== "General" && !match.params.id && (
                                                <Meters mode="department" department_id={activeDepartmentId} />
                                            )}
                                            {match.params.id && <Meters mode="risk" risk_id={match.params.id} />}
                                        </div>
                                    </div>

                                    {activeDepartment !== "General" && !match.params.id && (
                                        <DepartmentDashboard
                                            department_id={activeDepartmentId}
                                            setDepartmentDashboardData={setDepartmentDashboardData}
                                        />
                                    )}

                                    {match.params.id && <RiskDashboard match={match} />}
                                </div>
                            ) : menuitem === "risk" ? (
                                <Risk activeDepartmentId={activeDepartmentId} activeDepartment={activeDepartment} />
                            ) : menuitem === "files" ? (
                                <Files department_id={activeDepartmentId} />
                            ) : menuitem === "controls" ? (
                                <Control />
                            ) : menuitem === "inventory" ? (
                                <ITInventory />
                            ) : menuitem === "workflows" ? (
                                <Workflows />
                            ) : menuitem === "incidents" ? (
                                <IncidentList activeDepartmentId={activeDepartmentId} activeDepartment={activeDepartment} />
                            ) : menuitem === "workflow-editor" ? (
                                <div className="min-w-0 flex-1 overflow-auto">
                                    <WorkflowEditor
                                        setMenuItem={setMenuItem}
                                        setActiveRiskForWorkflow={setActiveRiskForWorkflow}
                                        setActiveAssetForWorkflow={setActiveAssetForWorkflow}
                                    />
                                </div>
                            ) : menuitem === "create_report" ? (
                                <Reports />
                            ) : (
                                <Gantt activeDepartmentId={activeDepartmentId} activeDepartment={activeDepartment} />
                            )}
                        </>
                    )}

                </div>
            </div>


        </div>

    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        sidebar_collapsed: state.auth.sidebar_collapsed,

        // departments: state.department.departments.filter(
        //     (dept) => dept.name !== "IT"
        // ),

        departments: state.department.departments,
        activeDepartmentId: state.department.activeDepartmentId,
        activeComplianceId: state.compliance.activeComplianceId,
        companies: state.department.companies,
        complianceStandards: state.compliance.complianceStandards,


    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentsFN: () => dispatch(getDepartments()),
        getAllDepartmentsFN: () => dispatch(getAllDepartments()),
        resetGotoRiskDashboardFN: () => dispatch(resetGotoRiskDashboard()),
        resetGotoBowtieFN: () => dispatch(resetGotoBowtie()),
        resetDepartmentDashboardFN: () => dispatch(resetDepartmentDashboard()),
        setActiveDepartmentId: (department_id) => dispatch(setActiveDepartment(department_id)),
        setActiveComplianceFN: (compliance_id) => dispatch(setActiveCompliance(compliance_id)),
        getDepartmentDashboardDataFN: (department_id) => dispatch(getDepartmentDashboardData(department_id)),
        getCompaniesFN: () => dispatch(getCompanies()),
        getComplianceStandardsByCompanyFN: () => dispatch(getComplianceStandardsByCompany()),
        setSidebarCollapsedFN: (collapsed) => dispatch(setSidebarCollapsed(collapsed)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Units);
